import { render, staticRenderFns } from "./FormCreateBranch.vue?vue&type=template&id=3d67af58&"
import script from "./FormCreateBranch.vue?vue&type=script&lang=js&"
export * from "./FormCreateBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports